import {
  Form,
  Input,
  FormButton,
  SubmitFeedback,
  StretchDiv,
  VStack,
} from 'admin-web-ui'
import { Store } from 'rc-field-form/lib/interface'
import React, { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { useAsyncFn } from 'react-use'
import styled from 'styled-components'

const StyledLink = styled(Link)`
  font-weight: 600;
`
interface Props {
  onSubmit: (values: FormData) => Promise<void>
}

export interface FormData {
  email: string
  password: string
}

export const LoginForm = (props: Props): JSX.Element => {
  const { onSubmit } = props

  const [submitState, submit] = useAsyncFn(
    async (values?: Store) => {
      if (!values) {
        return undefined
      }

      await onSubmit(values as FormData)
    },
    [onSubmit],
  )

  const resetSubmitError = useCallback(() => {
    submit(undefined)
  }, [submit])

  return (
    <Form onFinish={submit} onFieldsChange={resetSubmitError}>
      <VStack spacing={20}>
        <StretchDiv>
          <Form.Item
            name="email"
            validateStatus={submitState.error && 'error'}
            rules={[
              { type: 'email', message: 'Please enter a valid email address' },
              { required: true, message: 'Please input your email address' },
            ]}
          >
            <Input type="email" placeholder="Email" autoComplete="email" />
          </Form.Item>

          <Form.Item
            name="password"
            validateStatus={submitState.error && 'error'}
            rules={[{ required: true, message: 'Please input your password' }]}
          >
            <Input.Password
              autoComplete="current-password"
              placeholder="Password"
            />
          </Form.Item>

          <SubmitFeedback type="error" show={!!submitState.error}>
            Login failed. Please try again.
          </SubmitFeedback>
        </StretchDiv>

        <StretchDiv>
          <VStack align="center">
            <FormButton.Submit loading={submitState.loading}>
              Log in
            </FormButton.Submit>
            <StyledLink to="/forgot-password">Forgot password?</StyledLink>
          </VStack>
        </StretchDiv>
      </VStack>
    </Form>
  )
}
